export const REQUEST_ADD_ATTESTATION = 'REQUEST_ADD_ATTESTATION';
export const ADD_ATTESTATION_SUCCESS = 'ADD_ATTESTATION_SUCCESS';
export const ADD_ATTESTATION_FAILED = 'ADD_ATTESTATION_FAILED';
export const REQUEST_LOAD_ATTESTATIONS = 'REQUEST_LOAD_ATTESTATIONS';
export const LOAD_ATTESTATIONS_SUCCESS = 'LOAD_ATTESTATIONS_SUCCESS';
export const LOAD_ATTESTATIONS_FAILED = 'LOAD_ATTESTATIONS_FAILED';
